export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "PO-Revision-Date": "2025-01-16T18:28:34.729Z",
    "Language": "pl-PL",
    "Messages": {
        "Absolutne": "",
        "Adres": "",
        "Adres email": "",
        "Ai": "",
        "Akcje warstwy": "",
        "Akcje widgetu": "",
        "Aktualna karta": "",
        "Aktualne selektory dla których wyświetlane i edytowane są style": "",
        "Aktywne": "",
        "Angielski": "",
        "Animacja elementu": "",
        "Animacje": "",
        "Anuluj": "",
        "Arkusz styli": "",
        "Arkusze styli": "",
        "Auto": "",
        "Automatyczna": "",
        "Automatyczne odtwarzanie": "",
        "Bez limitu": "",
        "Biblioteka": "",
        "Błąd podczas dodawania urządzenia": "",
        "Błędna szerokość": "",
        "Blur": "",
        "brak": "",
        "Brak": "",
        "Brak animacji": "",
        "Brak elementów pasujących do wyszukiwania.": "",
        "Brak limitu": "",
        "Brak szablonów.": "",
        "Brak widgetów pasujących do wyszukiwania.": "",
        "Brak zawartości strony": "",
        "Cały tekst małą literą": "",
        "Cały tekst wielką literą": "",
        "Checkbox": "",
        "Cień": "",
        "Cofnij": "",
        "CSS": "",
        "Cytat": "",
        "Czas trwania": "",
        "Czas trwania (ms)": "",
        "Czas trwania zmiany styli (transition)": "",
        "Czcionka": "",
        "Czcionki": "",
        "Czy na pewno chcesz usunąć to urządzenie?": "",
        "Dekoracja": "",
        "Do lewej": "",
        "Do prawej": "",
        "Dodaj": "",
        "Dodaj element": "",
        "Dodaj klasę": "",
        "Dodaj kolejną klasę": "",
        "Dodaj kolejną opcję": "",
        "Dodaj kolejny arkusz styli": "",
        "Dodaj kolejny skrypt": "",
        "Dodaj kolor": "",
        "Dodaj niestandardowe urządzenie": "",
        "Dodaj nowy element listy": "",
        "Dodaj nowy slajd": "",
        "Dodaj szablon": "",
        "Dodaj warstwę": "",
        "Dodatkowy element": "",
        "Dolny": "",
        "Domyślny": "",
        "Dostępne klasy": "",
        "Duplikuj": "",
        "Duży komputer": "",
        "Duży telefon": "",
        "Dwie kolumny w wierszu": "",
        "Dziedziczona": "",
        "ease": "",
        "ease-in": "",
        "ease-in-out": "",
        "ease-out": "",
        "Edycja": "",
        "Edytor kodu CSS": "",
        "Edytor kodu HTML": "",
        "Edytor kodu JavaScript": "",
        "Edytor kodu Vue": "",
        "Edytor komponentu React": "",
        "Edytuj": "",
        "Edytuj kod CSS": "",
        "Edytuj kod HTML": "",
        "Edytuj kod JavaScript": "",
        "Edytuj kod Vue": "",
        "Edytuj komponent React": "",
        "Edytuj style": "",
        "Edytuj szablon": "",
        "Efekty": "",
        "Eksportuj stronę": "",
        "Eksportuj widget": "",
        "Element {name}": "",
        "Element klikalny": "",
        "Element listy": "",
        "Elementy": "",
        "Etykieta": "",
        "Film": "",
        "Film YouTube": "",
        "Filtr": "",
        "Filtr tła": "",
        "Flex": "",
        "Formularz": "",
        "Francuski": "",
        "Funkcja": "",
        "Generuj tekst": "",
        "Globalna klasa": "",
        "Globalne kolory": "",
        "Górny": "",
        "Gradient": "",
        "Gradient promieniowy": "",
        "Grid": "",
        "Gruba": "",
        "Grubość obramowania": "",
        "Grubość tekstu": "",
        "Historia edycji": "",
        "Hover": "",
        "Id inputa": "",
        "Ikona": "",
        "Importuj stronę": "",
        "Importuj widget": "",
        "Indeksowanie": "",
        "Indeksuj": "",
        "Indykatory": "",
        "Indykatory poza sliderem": "",
        "Italic": "",
        "Jasność": "",
        "Jedna wartość": "",
        "Jednostka": "",
        "Język": "",
        "Klasy": "",
        "Kod": "",
        "Kod nie może być pusty": "",
        "Kod skopiowany.": "",
        "Kod strony": "",
        "Kod svg": "",
        "Koło": "",
        "Kolor": "",
        "Kolor obramowania": "",
        "Kolor strzałek": "",
        "Kolor tekstu": "",
        "Kolor wypełnienia indykatorów": "",
        "Kolory": "",
        "Kolumna": "",
        "Kolumny": "",
        "Komputer": "",
        "Konfiguracja": "",
        "Kontener": "",
        "Kontrast": "",
        "Kontrolki playera": "",
        "Kopiuj": "",
        "Kreator stron": "",
        "Krok": "",
        "Kursor": "",
        "Kwadrat": "",
        "Label": "",
        "Label dla inputa": "",
        "Laptop": "",
        "Lepkie": "",
        "Lewy": "",
        "Lewy dolny": "",
        "Lewy dolny róg": "",
        "Lewy górny": "",
        "Lewy górny róg": "",
        "Liczba widocznych slajdów": "",
        "Liczby dziesiętne": "",
        "Liczby rzymskie": "",
        "linear": "",
        "Linia ciągła": "",
        "Linia kropkowana": "",
        "Linia u dołu tekstu": "",
        "Linia u góry tekstu": "",
        "Linia wycentrowana": "",
        "Link": "",
        "Link do filmu YouTube": "",
        "LinkBox": "",
        "Lista": "",
        "Lista nienumerowana": "",
        "Lista numerowana": "",
        "Maks. szerokość": "",
        "Maks. wysokość": "",
        "Maksymalna szerokość": "",
        "Maksymalna szerokość w px": "",
        "Mały tablet": "",
        "Mały telefon": "",
        "Mapa": "",
        "Margines": "",
        "Menadżer urządzeń": "",
        "Metoda": "",
        "Min. szerokość": "",
        "Min. wysokość": "",
        "Motywy": "",
        "Nagłówek": "",
        "Nagłówek 1": "",
        "Nagłówek 2": "",
        "Nagłówek 3": "",
        "Nagłówek 4": "",
        "Nagłówek 5": "",
        "Narzędzia AI": "",
        "Narzędzia kreatora": "",
        "Narzędzia strony": "",
        "Następny slajd": "",
        "Nawigacja": "",
        "Nazwa": "",
        "Nazwa klasy": "",
        "Nazwa koloru": "",
        "Nazwa koloru jest wymagana": "",
        "Nazwa koloru już istnieje": "",
        "Nazwa musi mieć minimum 2 znaki": "",
        "Nazwa nie może być pusta": "",
        "Nazwa skryptu": "",
        "Nazwa szablonu": "",
        "Nazwa urządzenia": "",
        "Nazwa warstwy": "",
        "Nie indeksuj": "",
        "Nie posiadasz uprawnień aby zaimportować komponent": "",
        "Nie posiadasz uprawnień aby zapisać komponent": "",
        "Nie posiadasz uprawnień do dodania nowego motywu": "",
        "Nie posiadasz uprawnień do edycji zapisanego komponentu": "",
        "Nie posiadasz uprawnień do usunięcia motywu": "",
        "Nie posiadasz uprawnień do usunięcia zapisanego komponentu": "",
        "Nie powtarzaj": "",
        "Nie udało się pobrać definicji widgetu": "",
        "Nie udało się pobrać szablonów": "",
        "Nie udało się pobrać widgetów": "",
        "Nie udało się skopiować kodu.": "",
        "Nie udało się usunąć szablonu.": "",
        "Nie udało się wczytać widgetu.": "",
        "Nie udało się wygenerować tekstu": "",
        "Nie udało się zaimportować widgetu": "",
        "Nie udało się zaktualizować widgetu": "",
        "Nie udało się zapisać widgetu": "",
        "Nie wyświetlaj": "",
        "Nie zawijaj": "",
        "Niemiecki": "",
        "Nienumerowana": "",
        "Nieparzysty element": "",
        "Nieprawidłowy format koloru": "",
        "Nieruchome": "",
        "Niestandardowe": "",
        "Normalna": "",
        "Nowa karta": "",
        "np. checkbox-1": "",
        "np. https://ideo.pl": "",
        "np. Jan": "",
        "np. Nad przyrwą 13": "",
        "np. radio-1": "",
        "np. Tekst opisowy": "",
        "np. Twoje imie": "",
        "Numerowana": "",
        "Obetnij nadmiar": "",
        "Obramowanie": "",
        "Obrót odcieni": "",
        "Odblokuj": "",
        "Odepnij": "",
        "Odległość między elementami": "",
        "Odległość między slajdami (px)": "",
        "Odległość od dolnej krawędzi": "",
        "Odległość od górnej krawędzi": "",
        "Odległość z lewej strony": "",
        "Odległość z prawej strony": "",
        "Odstęp dookoła elementów": "",
        "Odstęp pomiędzy elementami": "",
        "Odwrócenie": "",
        "Odziedzoczono po": "",
        "Offset x": "",
        "Offset Y": "",
        "Opcje": "",
        "Opis dla open graph": "",
        "Opis strony": "",
        "Opóźnienie (ms)": "",
        "Osobno dla boków": "",
        "Ostatnie kolory": "",
        "Otwórz kreator stron": "",
        "Padający cień": "",
        "Padding": "",
        "Page builder": "",
        "Page Builder": "",
        "Paragraf": "",
        "Parzysty element": "",
        "Pasek progresu": "",
        "Podaj szerokość w px": "",
        "Podany kod jest niepoprawny, w konsoli znajdują się informacje o błędach": "",
        "Podgląd": "",
        "Podkreślenie": "",
        "Podpowiedź": "",
        "Pogrubienie": "",
        "Pojedyńcza kolumna": "",
        "Pokaż": "",
        "Pokaż etykietę": "",
        "Pokaż więcej": "",
        "Położenie": "",
        "Polski": "",
        "Pomniejsz": "",
        "Pomoc": "",
        "Ponów": "",
        "Poprzedni slajd": "",
        "Powiększ": "",
        "Powiększenie": "",
        "Powiększenie kanwy": "",
        "Powrzarzanie tła": "",
        "Powtarzaj": "",
        "Powtarzaj horyzontalnie": "",
        "Powtarzaj wertykalnie": "",
        "Pozycja": "",
        "Pozycja tła": "",
        "Prawy": "",
        "Prawy dolny": "",
        "Prawy dolny róg": "",
        "Prawy górny": "",
        "Prawy górny róg": "",
        "Prezentacja": "",
        "Prosty": "",
        "Przeciągnij {name}": "",
        "Przejdź wyżej": "",
        "Przekierowanie": "",
        "Przekreślenie": "",
        "Przełącz edycję styli klas": "",
        "Przełącz obramowanie": "",
        "Przełącz rozwinięcie": "",
        "Przenieś warstwę": "",
        "Przesunięcie": "",
        "Przesunięcie w dół": "",
        "Przesunięcie w górę": "",
        "Przesunięcie w lewo": "",
        "Przesunięcie w prawo": "",
        "Przeźroczystość": "",
        "Przycisk": "",
        "Przykładowy tekst": "",
        "Przypnij do lewej krawędzi": "",
        "Przypnij do prawej krawędzi": "",
        "Radio": "",
        "React": "",
        "Relatywne": "",
        "Resetuj wymiary": "",
        "Równe odstępy": "",
        "Rozbudowany": "",
        "Rozbuduj tekst": "",
        "Rozciągnij": "",
        "Rozmiar": "",
        "Rozmiar strzałek": "",
        "Rozmiar tekstu": "",
        "Rozmycie": "",
        "Rozstaw liter": "",
        "Saturacja": "",
        "Schowaj": "",
        "Sekcja": "",
        "Selektor kolorów": "",
        "SEO": "",
        "Separator": "",
        "Sepia": "",
        "SFC": "",
        "Sformatuj poprawnie nazwę klasy": "",
        "Skala 100%": "",
        "Skala szarości": "",
        "Skrypt": "",
        "Skrypt aktywny": "",
        "Skrypty": "",
        "Slajd": "",
        "Slajder": "",
        "Sposób wprowadzania koloru": "",
        "Sposób wprowadzania wartości": "",
        "Spread": "",
        "Środek dolnej krawędzi": "",
        "Środek górnej krawędzi": "",
        "Środek kontenera": "",
        "Środek lewej krawędzi": "",
        "Środek prawej krawędzi": "",
        "Stan": "",
        "Stan elementu": "",
        "Statyczne": "",
        "Strona nie ma jeszcze zawartości": "",
        "Strona zbudowana w Page Builderze": "",
        "Strzałki poza slajderem": "",
        "Styl": "",
        "Styl obramowania": "",
        "Styl tekstu": "",
        "Style": "",
        "Style nie mogą być puste": "",
        "Style tekstu": "",
        "Szablon": "",
        "Szablon aktywny": "",
        "Szablon nie został pobrany": "",
        "Szablon nie został usunięty": "",
        "Szablon nie został zapisany": "",
        "Szablon został usunięty": "",
        "Szablon został zapisany": "",
        "Szerokość": "",
        "Szerokość ekranu (px)": "",
        "Szerokość w pikselach": "",
        "Szukaj elementu": "",
        "Szukaj elementu…": "",
        "Szukaj w bibliotece": "",
        "Szukaj w bibliotece…": "",
        "Tablet": "",
        "Target": "",
        "Tej operacji nie można cofnąć.": "",
        "Tekst": "",
        "Tekst alternatywny": "",
        "Telefon": "",
        "Tło": "",
        "Tłumaczenie": "",
        "Transformacja": "",
        "Tryb kreatora": "",
        "Tryb układu": "",
        "Twój adres email": "",
        "Twoje imie": "",
        "Typ": "",
        "Typ listy": "",
        "Typ nagłówka": "",
        "Typ przycisku": "",
        "Tytuł": "",
        "Tytuł dla open graph": "",
        "Tytuł strony": "",
        "Układ": "",
        "Ułóż sekcje i bloki w kreatorze stron": "",
        "Ułóż sekcje i bloki w kreatorze stron.": "",
        "Ułożenie elementów": "",
        "Ułożenie elementów według głównej osi": "",
        "Ułożenie elementów według osi poprzecznej": "",
        "Urządzenia": "",
        "Urządzenie podglądu": "",
        "Usuń": "",
        "Usuń element": "",
        "Usuń kolor": "",
        "Usuń szablon": "",
        "Usuń urządzenie": "",
        "Usuń warstwę": "",
        "Usuń wymiar": "",
        "Usuń zawartość": "",
        "Usuń zawartość strony": "",
        "Usunąć ten szablon?": "",
        "Utwórz": "",
        "Użyj styli zgodnych z CSS3": "",
        "W pionie": "",
        "W poziomie": "",
        "Warstwy": "",
        "Wartość": "",
        "Wartość koloru jest wymagana": "",
        "Wartość w pikselach": "",
        "Wczytywanie biblioteki": "",
        "Wczytywanie szablonów": "",
        "Wewnętrzny": "",
        "Widget": "",
        "Widget nie został usunięty": "",
        "Widget został usunięty": "",
        "Widget został zaimportowany": "",
        "Widget został zaktualizowany": "",
        "Widget został zapisany": "",
        "Widoczność": "",
        "Wielka litera": "",
        "Wiersz": "",
        "Wiersze": "",
        "Włącz pełny ekran": "",
        "Własne": "",
        "Własne polecenie": "",
        "Własny kod CSS": "",
        "Własny kod HTML": "",
        "Własny kod JavaScript": "",
        "Własny kod React": "",
        "Własny kod Vue": "",
        "Własny widget": "",
        "Wpisywanie tekstu": "",
        "Wpisz polecenie": "",
        "Wpisz tutaj cytat": "",
        "Wpisz tutaj swój nagłówek": "",
        "Wpisz tutaj tekst": "",
        "Wprowadź modyfikację": "",
        "Wrapper": "",
        "Wróć do edycji": "",
        "Wszystkie sekcje i bloki zostaną usunięte z płótna.": "",
        "Wszystko": "",
        "Wybierz czcionki": "",
        "Wybierz kolor": "",
        "Wybierz opcję": "",
        "Wycentrowanie": "",
        "Wycisz film": "",
        "Wyczyść": "",
        "Wyczyść formularz": "",
        "Wyczyść właściwość": "",
        "Wyczyścić całą stronę?": "",
        "Wyczyszczenie formularza formularza": "",
        "Wygenerowany tekst": "",
        "Wygląd listy": "",
        "Wymagany": "",
        "Wymiary dokumentu": "",
        "Wymiary kanwy": "",
        "Wyrównanie do końca": "",
        "Wyrównanie do początku": "",
        "Wyrównanie tekstu": "",
        "Wysokość": "",
        "Wysokość linii": "",
        "Wysokość w pikselach": "",
        "Wyśrodkowanie": "",
        "Wystąpił błąd podczas próby exportu strony.": "",
        "Wystąpił błąd podczas próby exportu widgetu.": "",
        "Wystąpił błąd podczas próby importu strony.": "",
        "Wystąpił błąd podczas próby importu widgetu.": "",
        "Wystąpił błąd podczas zapisywania kodu CSS": "",
        "Wystąpił błąd podczas zapisywania kodu HTML": "",
        "Wystąpił błąd podczas zapisywania kodu JavaScript": "",
        "Wystąpił błąd podczas zapisywania komponentu React": "",
        "Wyświetl kod": "",
        "YouTube": "",
        "Zaawansowany": "",
        "Zablokuj": "",
        "Zaktualizuj": "",
        "Zamień wymiary": "",
        "Zamknij": "",
        "Zanikanie": "",
        "Zaokgrąglenie rogów": "",
        "Zapętlaj": "",
        "Zapisywanie formularza": "",
        "Zapisz": "",
        "Zapisz formularz": "",
        "Zarządzaj urządzeniami": "",
        "Zawartość gotowa do edycji": "",
        "Zawartość jest gotowa do edycji.": "",
        "Zawijaj": "",
        "Zawijanie elementow": "",
        "Zaznacz komponent, aby edytować animacje.": "",
        "Zaznaczony": "",
        "Zaznaczony tekst": "",
        "Zdjęcie": "",
        "Zdjęcie dla open graph": "",
        "Zewnętrzny": "",
        "Zmień nazwę": "",
        "Zmień rozmiary": "",
        "Zmień wymiary dokumentu": "",
        "Zoom": "",
        "Zwykły przycisk": ""
    }
};
